import { useCallback, useEffect, useState } from "react";
import {
  getThumbnailOffenders,
  ThumbnailOffender,
} from "../api/getThumbnailOffenders";

interface UseImageRemediationResult {
  offenders: ThumbnailOffender[];
  loading: boolean;
  refetch: () => void;
}

export const useImageRemediation = (
  entityType?: "resource" | "event",
): UseImageRemediationResult => {
  const [offenders, setOffenders] = useState<ThumbnailOffender[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchOffenders = useCallback(() => {
    setLoading(true);
    getThumbnailOffenders({ entityType })
      .then((response) => {
        setOffenders(response.data.offenders);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [entityType]);

  useEffect(() => {
    fetchOffenders();
  }, [fetchOffenders]);

  return {
    offenders,
    loading,
    refetch: fetchOffenders,
  };
};
